import PropTypes from "prop-types";
import React, { Component } from "react";
import { Form } from "semantic-ui-react";
import CustomFieldForm from "../../../components/forms/CustomFieldForm";
import {
  checkIsCustomFieldsReady,
  extractCustom,
  getCustomFieldsForSubmit,
  keyIsUnique,
} from "../../../components/helpers";
import RuvixxForm from "../../../components/RuvixxForm";
import CampaignService from "../../../services/Campaign";
import CustomFieldService from "../../../services/CustomField";
import UserService from "../../../services/User";

class EditCampaignTargetForm extends Component {
  static propTypes = {
    onSuccess: PropTypes.func.isRequired,
    campaignId: PropTypes.number.isRequired,
    entityId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      assignee: "",
      custom: [],
      customFieldConfigs: [],
      users: [],
      customFieldsLoaded: false,
    };
  }

  handleSelect = (e, { name, value }) => {
    this.setState({ [name]: value });
  };

  fetchUsers = async () => {
    const users = await UserService.getUsers();
    this.setState({
      users,
    });
  };

  fetchCustomFieldConfigs = async () => {
    let customFieldConfigs =
      await CustomFieldService.getCustomFieldConfigsForModel("CampaignTarget");
    this.setState({ customFieldConfigs, customFieldsLoaded: true });
  };

  handleUpdateCustomFieldConfigs = customFieldConfigs => {
    this.setState({ customFieldConfigs });
    this.handleUpdateCustomFields(
      customFieldConfigs
        .filter(cfc => cfc.required || cfc.selected)
        .map(cfc => ({ key: cfc.label, value: cfc.value }))
    );
  };

  handleUpdateCustomFields = customFields => {
    this.setState({ custom: customFields });
  };

  async componentDidMount() {
    const target = await CampaignService.getCampaignTarget(
      this.props.campaignId,
      this.props.entityId
    );
    const custom = extractCustom(target.custom_fields);
    this.fetchUsers();
    this.fetchCustomFieldConfigs();
    this.setState({
      assignee: target.assigned_email,
      custom: custom,
    });
  }

  handleSubmit = async e => {
    const { assignee, custom, customFieldConfigs } = this.state;
    const cust = getCustomFieldsForSubmit(customFieldConfigs, custom);
    await CampaignService.editCampaignTarget({
      campaign_id: this.props.campaignId,
      entity_id: this.props.entityId,
      assigned_email: assignee,
      custom: cust,
    });
  };

  isUnique = key => {
    return keyIsUnique({
      key: key,
      array: this.state.custom,
    });
  };

  render() {
    const { users, assignee, custom, customFieldConfigs, customFieldsLoaded } =
      this.state;
    const userOptions = users.map(user => {
      return { key: user.id, text: user.full_name, value: user.email };
    });
    return (
      <RuvixxForm
        ready={
          checkIsCustomFieldsReady(customFieldConfigs) && customFieldsLoaded
        }
        onSubmit={this.handleSubmit}
        onSuccess={this.props.onSuccess}
      >
        <Form.Select
          label="Assignee"
          placeholder="Select Assignee"
          name="assignee"
          onChange={this.handleSelect}
          search
          clearable
          options={userOptions}
          value={assignee}
        />
        {customFieldConfigs && (
          <CustomFieldForm
            modelType="CampaignTarget"
            customFields={custom}
            customFieldConfigs={customFieldConfigs}
            onUpdateCustomFieldConfigs={this.handleUpdateCustomFieldConfigs}
          />
        )}
      </RuvixxForm>
    );
  }
}

export default EditCampaignTargetForm;
